export default __webpack_public_path__ + "static/media/Sergei.7c435de7.jpg";